import { cn } from "../../classNames-DkX30VJU.js";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
import * as RSeparator from "@radix-ui/react-separator";
// src/components/Separator/Separator.tsx
const separatorVariants = cva([
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:self-stretch",
	"tw:before:content-['']",
	"tw:before:bg-border"
], {
	defaultVariants: {
		orientation: "vertical",
		size: "full"
	},
	compoundVariants: [
		{
			orientation: "horizontal",
			size: "full",
			className: ["tw:before:w-full"]
		},
		{
			orientation: "horizontal",
			size: "1/2",
			className: ["tw:before:w-1/2"]
		},
		{
			orientation: "horizontal",
			size: "3/4",
			className: ["tw:before:w-3/4"]
		},
		{
			orientation: "vertical",
			size: "full",
			className: ["tw:before:h-full"]
		},
		{
			orientation: "vertical",
			size: "1/2",
			className: ["tw:before:h-1/2"]
		},
		{
			orientation: "vertical",
			size: "3/4",
			className: ["tw:before:h-3/4"]
		}
	],
	variants: {
		size: {
			full: ["tw:before:h-full"],
			"1/2": [],
			"3/4": []
		},
		orientation: {
			vertical: ["tw:before:w-px"],
			horizontal: ["tw:before:h-px"]
		}
	}
});
const Separator = ({ className, orientation = "vertical", size = "full", label, ...props }) => {
	if (label != null && label !== false) return /* @__PURE__ */ jsx(RSeparator.Root, {
		...props,
		decorative: true,
		orientation: "horizontal",
		className: cn("tw:flex tw:w-full tw:items-center tw:gap-3 tw:self-stretch", "tw:text-xs tw:font-medium tw:text-muted-foreground", "tw:before:content-[''] tw:before:h-px tw:before:flex-1 tw:before:bg-border", "tw:after:content-[''] tw:after:h-px tw:after:flex-1 tw:after:bg-border", className),
		children: label
	});
	return /* @__PURE__ */ jsx(RSeparator.Root, {
		...props,
		decorative: true,
		orientation,
		className: separatorVariants({
			size,
			orientation,
			className
		})
	});
};
export { Separator };

//# sourceMappingURL=Separator.js.map